import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export var openCommentsThread = createAction(actionKey + "/OPEN_COMMENTS_THREAD", function (streamId) { return ({
    streamId: streamId,
}); });
export var closeAllCommentThreads = createAction(actionKey + "/CLOSE_ALL_COMMENT_THREADS", function () { return ({}); });
//# sourceMappingURL=actions.js.map